import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { notificationSuccess, notificationError } from '../../../../core/actions';
import { setClientDetailsTagList } from '../../../../reducers/client';
import { addTagToClient, removeTagFromClient } from '../../../../services/clients';
import { getClientErrorMessage } from '../../../../services/clientErrors';
import { withRetry } from '../../../../services/apiRetry';

const TagManagerModalV2 = props => {
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagsToSend] = useState({});
  const [filterTags, setFilterTags] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const tagList = props.client?.details_tag_list || [];
    setSelectedTags([
      ...tagList.sort((a, b) => {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return -1;
      }),
    ]);
  }, []);

  const setTagHandler = id => {
    // sets a Tags as a "selectedTags", while trying to avoid dupes
    let tagAccess;
    const tagList = selectedTags.map(tag => {
      if (id === tag.id) {
        if (tag.client_id) {
          tag.client_id = null;
          tagAccess = false;
        } else {
          tag.client_id = props.client.client_id;
          tagAccess = true;
        }
      }
      return tag;
    });
    if (tagsToSend[id]) {
      delete tagsToSend[id];
    } else {
      tagsToSend[id] = tagAccess;
    }
    setSelectedTags([...tagList]);
  };

  const saveTagAccess = async () => {
    if (isSaving) {
      return; // Prevent concurrent saves
    }

    setIsSaving(true);
    const clientId = props.client?.client_id;

    if (!clientId) {
      notificationError('Error: Client ID not found');
      setIsSaving(false);
      return;
    }

    try {
      const tagIds = Object.keys(tagsToSend);

      if (tagIds.length === 0) {
        // No changes to save
        props.showTagManagerHandler(false);
        return;
      }

      // Process all tag operations in parallel using Promise.allSettled with retry
      const operations = tagIds.map(tagId => {
        const shouldAdd = tagsToSend[tagId];
        const tagIdNum = Number(tagId);

        // Wrap each operation with retry logic for transient failures
        return withRetry(
          () =>
            shouldAdd
              ? addTagToClient({ clientId, tagId: tagIdNum, loadingStatusOff: true })
              : removeTagFromClient({ clientId, tagId: tagIdNum, loadingStatusOff: true }),
          { maxRetries: 2, baseDelayMs: 500 },
        );
      });

      const results = await Promise.allSettled(operations);

      // Count successes and failures for partial failure handling
      const failures = results.filter(r => r.status === 'rejected');
      const successes = results.filter(r => r.status === 'fulfilled');

      if (failures.length === 0) {
        notificationSuccess('Tags Saved To Client!');
      } else if (successes.length > 0) {
        // Partial success - some tags saved, some failed
        notificationSuccess(`Saved ${successes.length} of ${results.length} tag changes`);
        notificationError(`${failures.length} tag change(s) failed`);
        console.error('Tag operation failures:', failures.map(f => f.reason));
      } else {
        notificationError('Error Saving Tags To Client');
        console.error('All tag operations failed:', failures.map(f => f.reason));
      }

      props.showTagManagerHandler(false);
      setClientDetailsTagList(selectedTags);
      props.getClientData(clientId);
    } catch (error) {
      console.error('Unexpected error saving tags:', error);
      notificationError(getClientErrorMessage(error, 'Error saving tags to client'));
      props.showTagManagerHandler(false);
    } finally {
      setIsSaving(false);
    }
  };

  const searchHandler = val => {
    setSearchText(val);
    const lVal = val.toLowerCase();
    const filtered = selectedTags.filter(tag => {
      if (tag.name.toLowerCase().includes(lVal)) {
        return true;
      }
      return false;
    });
    if (val.length > 0) {
      setFilterTags([...filtered]);
    } else {
      setFilterTags([]);
    }
  };

  const whichList = () => {
    const tagList = props.client?.details_tag_list || [];
    const sortedTagsArr = [];
    tagList.forEach(tag => {
      if (tag.client_id === null) {
        sortedTagsArr.push(tag);
      }
    });
    sortedTagsArr.sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      return -1;
    });
    if (searchText) {
      return filterTags;
    }
    const selected = tagList.filter(tag => {
      if (tag.client_id !== null) {
        return tag;
      }
    });
    return selected.concat(sortedTagsArr);
  };

  return (
    <div className="pop-confirm-background" id="modal-background">
      <div className="pop-confirm-container rem-pad-width" style={{ width: '404px', height: '748px' }}>
        <div
          className="flex-col-center h-100-P"
          style={{
            justifyContent: 'flex-start',
            width: '295px',
            margin: '0 auto',
          }}
        >
          <div className="flex-row-spacebetween-nowrap w-100-P m-top-15">
            <div />
          </div>
          <span className="fs-18 fw-500" style={{ marginTop: '15px' }}>
            Edit Client Tags
          </span>
          <input
            placeholder="Search"
            value={searchText}
            onChange={e => searchHandler(e.target.value)}
            className="h-50 w-100-P m-top-18 m-btm-6 body-head-search rem-pad-width focus-input-outline-blue"
            style={{
              width: '100%',
              height: '50px',
              backgroundColor: '#EBEBEB',
            }}
          />

          <div
            style={{
              paddingTop: '25px',
              height: '600px',
              paddingLeft: '10px',
            }}
            className="w-295 rem-pad-width chatBubblePadding overflowY hide-scrollbar"
          >
            <ul className="ul-no-style flex-col-left ">
              {whichList()
                .filter(tag => tag.id !== 0)
                .map(tag => {
                  return (
                    <li
                      key={tag.id}
                      className="fs-14 flex-row-nospacebetween-nowrap m-btm-12 pointer w-100-P p-btm-13"
                      onClick={() => setTagHandler(tag.id)}
                      style={{ borderBottom: 'solid .5px #EBEBEB' }}
                    >
                      {tag.client_id ? (
                        <FontAwesomeIcon icon="fas fa-check-circle" className="fs-18 m-right-15" color="#000" />
                      ) : (
                        <FontAwesomeIcon icon="fa-regular fa-circle" className="fs-18 m-right-15" color="#000" />
                      )}
                      <span className="circle w-12 h-12 m-right-18" style={{ backgroundColor: tag.color }} />
                      <span className="fs-12 CBdarkBlue align-left" style={{ maxWidth: '73%' }}>
                        {tag.name}
                      </span>
                    </li>
                  );
                })}
            </ul>
          </div>
          <div className="mq-w-100-vw custom-action-save-flex m-top-15 m-btm-10">
            <button
              type="button"
              className="save-button-v2 m-btm-8"
              onClick={saveTagAccess}
              disabled={isSaving}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </button>
            <button
              type="button"
              className="cancel-button-v2"
              onClick={() => props.showTagManagerHandler(false)}
              disabled={isSaving}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagManagerModalV2;
